import React from "react";
import { Navbar } from "reactstrap";
import "./PanduNav.css";
import SubNav3 from "./SubNav3";
import { NavLink, MDBBtn } from "mdbreact";
import { Link } from "react-router-dom";
import { Typography, Grid, Button, Container } from "@material-ui/core";
import Header1 from "./Header";
import { Layout, Divider } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
const { Header } = Layout;
export default class PanduNav extends React.Component {
  state = {
    sticky: false,
    headerHidden: false,
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const isSticky = window.scrollY > 150;
    this.setState({
      sticky: isSticky,
      headerHidden: isSticky,
    });
  };

  render() {
    return (
      <>
        {/* <Header1 /> */}

        {/* MAIN HEADER */}
        {/* <Layout className="main-header-class">
          <Header className="main-header-header" style={{ padding: 0 }}> */}
          <Layout>
  <Header
    style={{
      padding: 0,
      background: "#0B3D2E",
      height: "auto",
      lineHeight: "normal",
    }}
  >
    <Container maxWidth="xl">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 200,
          paddingTop: 20,
          paddingBottom: 20,     // ✅ SAME as top
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        {/* LEFT : LOGO + COLLEGE NAME */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            color: "#FFFFFF",
          }}
        >
          <img
            src="/images/NSS-symbol.png"
            alt="NSS Logo"
            style={{
              width: 100,
              height: 100,          // ✅ fixed height
              objectFit: "contain",
              display: "block",
            }}
          />

          <div style={{ lineHeight: 1.2 }}>
            <div
              style={{
                fontSize: 20,
                fontWeight: 700,
                margin: 0,
              }}
            >
              Dispur College
            </div>
            <div
              style={{
                fontSize: 20,
                fontWeight: 600,
                margin: 0,
                marginTop: 2,
                opacity: 0.9,
              }}
            >
              National Service Scheme (NSS)
            </div>
          </div>
        </div>

        {/* CENTER : CONTACT INFO */}
        <div
          style={{
            textAlign: "center",
            color: "#FFFFFF",
            fontSize: 13,
            fontWeight: 600,
            lineHeight: 1.4,      // ✅ controlled
          }}
        >
          <div style={{ margin: 0 }}>
            <PhoneOutlined /> &nbsp; (+91) 9957903913(M)
          </div>
          <div style={{ marginTop: 4 }}>
            <MailOutlined /> &nbsp; nssdispurcollege01@gmail.com 
          </div>
        </div>

        {/* RIGHT : NAAC */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            color: "#FFFFFF",
          }}
        >
          <img
            src="/images/naac.webp"
            alt="NAAC"
            style={{
              width: 90,
              height: 90,         // ✅ same as logo
              objectFit: "contain",
              display: "block",
            }}
          />
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              maxWidth: 180,
              lineHeight: 1.3,
            }}
          >
            Accredited by NAAC with A Grade (3rd Cycle)
          </div>
        </div>
      </div>
    </Container>
  </Header>
</Layout>



        {/* SUB NAV */}
        <div style={{ backgroundColor: "#D6DBDF" }}>
          <SubNav3
            width="200px"
            color="#1E3760"
            backgroundOfNav="white"
            backgroundColor="#D6DBDF"
            textColor="white"
            history={this.props.history}
          />
        </div>
      </>
    );
  }
}


// export default class PanduNav extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       sticky: false,
//       headerHidden: false,
//     };
//   }

//   componentDidMount() {
//     window.addEventListener("scroll", this.handleScroll);
//   }

//   componentWillUnmount() {
//     window.removeEventListener("scroll", this.handleScroll);
//   }


//   handleScroll = () => {
//     if (window.scrollY < 150) {
//       this.setState({
//         sticky: false,
//         headerHidden: false,
//       });
//     } else if (window.scrollY > 150) {
//       this.setState({
//         sticky: true,
//         headerHidden: true,
//       });
//     }
//   };

//   render() {
//     return (
//       <div>
//         <Header1 />
//         <Layout className="main-header-class">
//           <Header
            
//             className="main-header-header"
//           >
//             <Container>
//               <div
//                 style={{
//                   backgroundColor: "#ED7D31",
//                   display: "flex",
//                   flexDirection: "row",
//                   alignItems: "center",
//                 }}
//               >
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={12} md={12} lg={12}>
//                     <div
//                       className="main-logo-text-div"
//                     >
//                       <a href="/">
//                         <img
//                           className="logo-img"
//                           src={"/images/nss.png"}
//                           alt="logo"
//                         />
//                       </a>
//                       <div style={{
//                         lineHeight: 1,
//                         fontFamily: "Gothic A1",
//                         fontSize: 12,
//                         fontWeight: 700,
//                         display: "flex",
//                         flexDirection: "column",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}>
//                       <div style={{ display: "flex", alignItems: "center", color: "white" }}>
//                         <PhoneOutlined style={{ fontSize: 16 }} /> &nbsp;
//                         80115-76322(O)
//                       </div>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           marginTop: 4,
//                           color: "white"
//                         }}
//                       >
//                         <MailOutlined style={{ fontSize: 16, color: "white" }} /> &nbsp;
//                         principal.eraligool@gmail.com
//                       </div>
//                       </div>
//                       <div className="naac-div-text">
//                         <img src={`/images/b-plus-bg.png`}  style={{width: 100}}/>
//                         <div className="naac-div-text-text">Accredited by NAAC with B+ Grade in 1st cycle</div>
//                       </div>
//                     </div>
//                   </Grid>

//                   <Grid item xs={12} sm={12} md={12} lg={12}>
//                     <div
//                       style={{
//                         lineHeight: 1.2,
//                         fontFamily: "Gothic A1",
//                         fontSize: 14,
//                         fontWeight: 700,
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                       }}
//                     >
                      
//                     </div>
//                     <div></div>
//                   </Grid> 
//                 </Grid>  
//               </div>
//             </Container>
//           </Header>
//         </Layout>

//         <div style={{ backgroundColor: "#D6DBDF" }}>
//           <SubNav3
//             // sticky={this.state.sticky}
//             width={`200px`}
//             color={`#1E3760`}
//             backgroundOfNav={`white`}
//             backgroundColor={`#D6DBDF`}
//             textColor={`white`}
//             history={this.props.history}
//           />
//         </div>

       
//       </div>
//     );
//   }
// }
 {/* for mobile */}
        {/* <div className="m-display">
          <Navbar expand="md" className="main-nav-class m-display">
            <a href="/">
              <img
                className="logo-img"
                src={
                  "/images/tnclogo.png"
                }
                alt="logo"
              />
            </a>
            <div
              className="navbar-div-text"
              style={{
                flexBasis: "auto",
                margin: "15px",
                padding: "0 10px",
              }}
            >
              <Typography className="nav-bar-div-text-h" variant="h1">
                {this.props.data != undefined ? <span>{this.props.data.dept_name_as}</span> : 'THONG NOKBE COLLEGE'}
              </Typography>
              <Typography className="nav-bar-div-text-h" variant="h4">
                {this.props.data != undefined ? <span>{this.props.data.dept_name}</span> : <img src="/images/tnctext.png" style={{ width: '6em' }} alt="" />}
              </Typography>
            </div>
          </Navbar>
        </div> */}